module.exports = __webpack_public_path__ + "static/img/4.350884f8.png";